import { render, staticRenderFns } from "./updHoctTerms.vue?vue&type=template&id=19efdab4"
import script from "./updHoctTerms.vue?vue&type=script&lang=js"
export * from "./updHoctTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports